import { Utils } from './../../../../shared/services/utils.service';
import { OrcamentoService } from './../../../../shared/services/orcamento.service';
import { EntrySelect } from './../../../../shared/models/EntrySelect.model';
import { Subject } from 'rxjs';
import { ProdutoServico } from './../../shared/model/produto-servico.model';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Veiculo } from '../../shared/model/veiculo.model';
import { FormGroup, FormBuilder, RequiredValidator, Validators } from '@angular/forms';
import { MessageService } from '../../../../shared/message.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VeiculoService } from '../../../../shared/services/veiculo.service';
import { environment } from '../../../../../environments/environment';
import { RestService } from '../../../../shared/services/rest.service'
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-validacao',
  templateUrl: './validacao.component.html',
  styleUrls: ['./validacao.component.css', './validacao.component.scss']
})
export class ValidacaoComponent implements OnInit {

  uuid: string = "";
  protocolo: string;
  resourceForm: FormGroup;
  progress_width: string = "0";
  progress_color: string = "red";
  isReadOnly: boolean = true;
  uuid_oficina: string
  nivel: Array<EntrySelect> = [
    { "value": "0", "label": "N/A" },
    { "value": "1", "label": "1/4" },
    { "value": "2", "label": "2/4" },
    { "value": "3", "label": "3/4" },
    { "value": "4", "label": "4/4" }
  ]
  //itens
  marcas: Array<EntrySelect> = [];
  geracoes: Array<EntrySelect> = [];
  modelos: Array<EntrySelect> = [];
  versoes: Array<EntrySelect> = [];
  veiculos: Array<EntrySelect> = [];
  coresVeiculo: Array<EntrySelect> = [];
  responsaveis: any;
  responsavel: any;
  tipoEmpResp: any;
  nomeEmpResp: any;
  uuidEmpResp: any;
  uuidEmpOrcamento: any;
  listaMarcas: Array<any>;
  fipe: string = null;
  dadosOriginais: any = {};
  isLoginSiga: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private info: MessageService,
    private rest: OrcamentoService,
    private restCiclo: VeiculoService,
    private serv: RestService,
    private session: SessionService,
  ) {
    //this.onFinalizar = new Subject;
    this.coresVeiculo = environment.coresVeiculo;
     let sessao = this.session.getUserSession();
    this.isLoginSiga= sessao.tokenSiga.length>0;

  }
  
  ngOnInit(): void {
    //validator form alterar senha
    this.resourceForm = this.formBuilder.group({
      protocolo: [null, [Validators.required]],
      placa: [null, [Validators.required]],
      marca_codigo: [null, [Validators.required]],
      marca_descricao: [null, [Validators.required]],
      geracao_codigo: [null, [Validators.required]],
      geracao_descricao: [null, [Validators.required]],
      modelo_codigo: [null, [Validators.required]],
      modelo_descricao: [null, [Validators.required]],
      versao_codigo: [null, [Validators.required]],
      versao_descricao: [null, [Validators.required]],
      veiculo_codigo: [null, [Validators.required]],
      veiculo_descricao: [null, [Validators.required]],
      cor: [null, [Validators.required]],
      quilometragem: [null, [Validators.required]],
      chassi: [null, [Validators.required]],
      combustivel: [null, [Validators.required]],
      /* usuario: [null,],
      usuarioEmpresa: [null,] */
    });
    this.setDados();
  }

  enableAlterar() {
    this.info.showConfirme("Tem certeza que deseja modificar os dados do veículo, isso removerá todas as peças já adicionada ao orçamento.")
      .then((result) => {
        if (result.isConfirmed) {
          this.resourceForm.get('marca_codigo')?.reset();
          this.resourceForm.get('geracao_codigo')?.reset();
          this.resourceForm.get('modelo_codigo')?.reset();
          this.resourceForm.get('versao_codigo')?.reset();
          this.resourceForm.get('veiculo_codigo')?.reset();
          this.getMarcas();
          this.isReadOnly = false;
        } else if (result.isDenied) {

        }
      })

  }

  onChangeCombustivel() {
    let combustivel = this.resourceForm.get('combustivel')?.value;
    if (combustivel == '0') {
      this.progress_color = "red";
      this.progress_width = "0%";
    } else if (combustivel == "1") {
      this.progress_color = "red";
      this.progress_width = "25%";
    } else if (combustivel == "2") {
      this.progress_color = "orange";
      this.progress_width = "50%";
    } else if (combustivel == "3") {
      this.progress_color = "#21db21";
      this.progress_width = "75%";
    }
    else if (combustivel == '4') {
      this.progress_color = "green";
      this.progress_width = "100%";
    }
  }

  getTipoEmpresaAtual() {//Obter qual o tipo da empresa que o orçamento esta atribuido
    let tipo = this.tipoEmpResp
    if (tipo != null && tipo != '') {
      if (this.nomeEmpResp != null) {
        if (tipo == 'CORPORATE') {
          this.responsavel = [
            { value: 0, label: this.nomeEmpResp },
            { value: 'Oficina', label: 'Oficina' },
            { value: 'Reguladora', label: 'Reguladora' }
          ];
        }
        else if (tipo == 'OFICINA') {
          this.responsavel = [
            { value: 0, label: this.nomeEmpResp },
            { value: 'Associação', label: 'Associação' },
            { value: 'Reguladora', label: 'Reguladora' }
          ];
        }
        else if (tipo == 'REGULADORA') {
          this.responsavel = [
            { value: 0, label: this.nomeEmpResp },
            { value: 'Associação', label: 'Associação' },
            { value: 'Oficina', label: 'Oficina' }
          ];
        }
        else { // caso não tenha usuário definido
          this.responsavel = [
            { value: 'Associação', label: 'Associação' },
            { value: 'Oficina', label: 'Oficina' },
            { value: 'Reguladora', label: 'Reguladora' }
          ];
        }
      }
    }
    else if (tipo == undefined) {
      this.responsavel = [
        { value: 'Associação', label: 'Associação' },
        { value: 'Oficina', label: 'Oficina' },
        { value: 'Reguladora', label: 'Reguladora' }
      ];
    }
    //console.log(this.responsavel)
  }

  onSelectEmp() {
    let tipo = this.resourceForm.get('usuarioEmpresa')?.value
    let postData = {
      "method": "GET",
      "uuidOrcamento": this.uuid,
      "tipo_emp": tipo,
      "uuid": ((tipo == 'Associação') ? (this.uuidEmpOrcamento) : ((tipo == 0) ? this.uuidEmpResp : null))
    }
    this.rest.getUsersByTipoEmpresa(postData).subscribe((data: any) => {
      if (data.mensagem != 'Empresa sem usuários registrados!') {
        this.responsaveis = []
        data.data.forEach((data) => {
          this.responsaveis.push({ "value": data.usuario, "label": ((data.fantasia == null || data.fantasia == '') ? this.nomeEmpResp : data.fantasia) + ' - ' + data.nome })
        })
        this.resourceForm.get('usuario').setValue('')
      }
      else this.responsaveis = null
    });
  }

  setDados() {
    this.resourceForm.get('protocolo')?.setValue(this.protocolo);
    //this.isReadOnly=true;
    //this.resourceForm.reset();
    this.rest.getOrcamentoProtocol(this.protocolo).subscribe(
      async data => {
        var response = JSON.parse(JSON.stringify(data));
        //console.log(response);
        let dados = response.data[0];
        this.rest.getOrcamentoProtocolEdicao(this.protocolo).subscribe((data2: any) => {
          this.dadosOriginais = data2.data
        });
        //console.log(dados);
        //uuid orçamento
        this.tipoEmpResp = dados.empresaatritipo;
        this.nomeEmpResp = dados.empresaatribuido;
        this.uuidEmpResp = dados.uuid_emp_atribuicao;
        this.uuidEmpOrcamento = dados.uuid_emp_orcamento;
        this.uuid = dados.uuid;
        this.uuid_oficina = dados.uuid_oficina;
        //this.getMarcas();
        //let marca = dados.marcaCodigo;
        //mao de obra
        //this.resourceForm.get('protocolo')?.setValue(dados.protocolo);
        this.resourceForm.get('usuario')?.setValue(dados.atribuicao);
        this.resourceForm.get('marca_codigo')?.setValue(dados.marca_codigo);
        this.resourceForm.get('marca_descricao')?.setValue(dados.marca_descricao);
        this.resourceForm.get('geracao_codigo')?.setValue(dados.geracao_codigo);
        this.resourceForm.get('geracao_descricao')?.setValue(dados.geracao_descricao);
        this.resourceForm.get('modelo_codigo')?.setValue(dados.modelo_codigo);
        this.resourceForm.get('modelo_descricao')?.setValue(dados.modelo_descricao);
        this.resourceForm.get('versao_codigo')?.setValue(dados.versao_codigo);
        this.resourceForm.get('versao_descricao')?.setValue(dados.versao_descricao);
        this.resourceForm.get('veiculo_codigo')?.setValue(dados.veiculo_codigo);
        this.resourceForm.get('veiculo_descricao')?.setValue(dados.veiculo_descricao);
        this.resourceForm.get('placa')?.setValue(dados.placa);
        this.resourceForm.get('cor')?.setValue(dados.cor);
        this.resourceForm.get('quilometragem')?.setValue(dados.quilometragem);
        this.resourceForm.get('chassi')?.setValue(dados.chassi);
        this.fipe = dados.fipe;
        dados.atribuicaonome == null ? this.responsaveis = null : this.responsaveis = [{ "value": 0, "label": dados.empresaatribuido + ' - ' + dados.atribuicaonome }]
        this.resourceForm.get('usuario')?.setValue(this.responsaveis == null ? null : 0);
        let combustivel
        //console.log(dados.nivel_combustivel)
        if (dados.nivel_combustivel == undefined || dados.nivel_combustivel == '/4' || dados.nivel_combustivel == null || dados.nivel_combustivel == '') {
          this.resourceForm.get('combustivel')?.setValue('0');
        } else {
          combustivel = dados.nivel_combustivel.split('/')[0];
          this.resourceForm.get('combustivel')?.setValue(combustivel);
        }
        //console.log(combustivel)
        this.onChangeCombustivel();

        //console.log(this.resourceForm.get('marca_codigo'));

        //console.log(dados)
      })
  }

  getMarcas() {
    this.restCiclo.getMarcas().subscribe(
      data => {
        //console.log(data)
        var res = JSON.parse(JSON.stringify(data))
        var returnMarcas = res.data;
        this.listaMarcas = res.data;
        let marcas: Array<EntrySelect> = []
        returnMarcas.forEach(item => {
          if (item.bdPecas == 'Nao') {
            marcas.push({ "value": item.codigoMarca, "label": item.descricaoMarca, "value_other": 'Sem Peças' })

          } else {
            marcas.push({ "value": item.codigoMarca, "label": item.descricaoMarca })
          }
        })
        this.marcas = marcas;
      }
    )
  }

  getGeracoes() {
    let idSetMarca = this.resourceForm.get('marca_codigo')?.value
    if (idSetMarca == "" || idSetMarca == null) {
      this.geracoes = []
      return
    }
    this.restCiclo.getMarca(idSetMarca).subscribe(
      data => {
        let geracoes: Array<EntrySelect> = [];
        data.data.geracoes.forEach(item => {
          if (item.bdPecas == 'Nao') {
            geracoes.push({ "value": item.codigoGeracao, "label": item.descricaoGeracao, "value_other": 'Sem Peças' })

          } else {
            geracoes.push({ "value": item.codigoGeracao, "label": item.descricaoGeracao })
          }
        })
        this.geracoes = geracoes;
      }
    )
  }

  getModelos() {
    //ese set não pode
    //this.resourceForm.value.geracao == valor
    let idGeracao = this.resourceForm.get('geracao_codigo')?.value
    //console.log("setGera"+" "+idGeracao)

    if (idGeracao == "" || idGeracao == null) {
      this.modelos = []
      return
    }

    this.restCiclo.getGeracao(idGeracao).subscribe(
      data => {
        let modelos: Array<EntrySelect> = []
        data.data.modelos.forEach(item => {
          //console.log(item)
          modelos.push({ "value": item.codigoModelo, "label": item.descricaoModelo, "value_other": (item.bdPecas == 'Nao') ? 'Sem Peças' : '' })
        });
        this.modelos = modelos;
      }

    )

  }

  getVersoes() {
    // this.resourceForm.value.versao = valor.toString()
    let idModelo = this.resourceForm.get('modelo_codigo')?.value
    //console.log("setModelo"+" "+idModelo)

    if (idModelo == "") {
      this.versoes = []
      return
    }

    this.restCiclo.getModelo(idModelo).subscribe(
      data => {
        let versoes: Array<EntrySelect> = []
        //console.log(data.data.versoes);
        data.data.versoes.forEach(item => {
          //console.log(item)
          versoes.push({ "value": item.codigoVersao, "label": item.descricaoVersao })
        });
        this.versoes = versoes;

      }
    )
  }

  getVeiculos() {
    let idVersao = this.resourceForm.get('versao_codigo')?.value

    if (idVersao == "") {
      this.veiculos = []
      return
    }
    this.restCiclo.getVersao(idVersao).subscribe(
      data => {
        let veiculos: Array<EntrySelect> = []
        data.data.veiculos.forEach(item => {
          //console.log(item)
          veiculos.push({ "value": item.codigoVeiculo, "label": item.anoModelo, "value_other": item.valorFipe })
        });
        this.veiculos = veiculos;
      }
    )
  }

  obterLogo() {
    if (!this.isReadOnly) {
      let cod = this.resourceForm.get('marca_codigo').value;
      for (let i = 0; i < this.listaMarcas.length; i++) {
        if (this.listaMarcas[i].codigoMarca == cod) {
          return this.listaMarcas[i].link;
        }
      }
    }
    return null
  }

  onChangeMarca(event) {
    this.resourceForm.get('marca_descricao')?.setValue(event ? event.label : null);
    this.obterLogo()
    this.getGeracoes()
    this.resourceForm.get('geracao_codigo')?.setValue(null);//clean value
    //console.log(this.marca)
    //console.log(this.resourceForm.get('marca'))
  }

  onChangeGeracao(event) {
    this.resourceForm.get('geracao_descricao')?.setValue(event ? event.label : null);
    //console.log(this.resourceForm.get('geracao'));
    this.getModelos()
    this.resourceForm.get('modelo_codigo')?.setValue(null);//clean value
  }

  onChangeModelo(event) {
    this.resourceForm.get('modelo_descricao')?.setValue(event ? event.label : null);
    this.getVersoes()
    this.resourceForm.get('versao_codigo')?.setValue(null);//clean value
  }

  onChangeVersao(event) {
    this.resourceForm.get('versao_descricao')?.setValue(event ? event.label : null);
    this.getVeiculos()
    this.resourceForm.get('veiculo_codigo')?.setValue(null);//clean value

  }

  onChangeVeiculo(event) {
    this.resourceForm.get('veiculo_descricao')?.setValue(event ? event.label : null);
    this.fipe = event ? event.value_other : null
  }

  checkIdGroup(grupoIds = []) {
    return this.session.checkInGrupo(grupoIds)
  }

  onSubmit() {
    //console.log(this.resourceForm);

    if (this.resourceForm.invalid) {
      //console.log(this.resourceFormPeca)
      this.resourceForm.markAllAsTouched();
      return;
    }
    this.dadosOriginais.dataCar = {
      "placa": String(this.resourceForm.get('placa')?.value),
      "chassi": String(this.resourceForm.get('chassi')?.value),
      "quilometragem": String(this.resourceForm.get('quilometragem')?.value),
      "marcaCodigo": String(this.resourceForm.get('marca_codigo')?.value),
      "marcaDescricao": String(this.resourceForm.get('marca_descricao')?.value),
      "geracaoCodigo": String(this.resourceForm.get('geracao_codigo')?.value),
      "geracaoDescricao": String(this.resourceForm.get('geracao_descricao')?.value),
      "modeloCodigo": String(this.resourceForm.get('modelo_codigo')?.value),
      "modeloDescricao": String(this.resourceForm.get('modelo_descricao')?.value),
      "versaoCodigo": String(this.resourceForm.get('versao_codigo')?.value),
      "versaoDescricao": String(this.resourceForm.get('versao_descricao')?.value),
      "veiculoCodigo": String(this.resourceForm.get('veiculo_codigo')?.value),
      "veiculoDescricao": String(this.resourceForm.get('veiculo_descricao')?.value),
      "veiculoCor": String(this.resourceForm.get('cor')?.value),
      "veiculoNivelCombustivel": String(this.resourceForm.get('combustivel')?.value + '/4'),
      "link": this.obterLogo(),
      "fipe": this.fipe
    }
    //console.log(this.resourceForm.get('combustivel')?.value);return;

    let postData = {
      "uuidOrcamento": this.uuid,
      "protocolo": String(this.resourceForm.get('protocolo')?.value),
      "status": "EXECUÇÃO",
      /* "responsavel": (this.resourceForm.get('usuario')?.value == 0 ? null : this.resourceForm.get('usuario')?.value), */
      "dataCar": {
        "placa": String(this.resourceForm.get('placa')?.value),
        "chassi": String(this.resourceForm.get('chassi')?.value),
        "quilometragem": String(this.resourceForm.get('quilometragem')?.value),
        "marcaCodigo": String(this.resourceForm.get('marca_codigo')?.value),
        "marcaDescricao": String(this.resourceForm.get('marca_descricao')?.value),
        "geracaoCodigo": String(this.resourceForm.get('geracao_codigo')?.value),
        "geracaoDescricao": String(this.resourceForm.get('geracao_descricao')?.value),
        "modeloCodigo": String(this.resourceForm.get('modelo_codigo')?.value),
        "modeloDescricao": String(this.resourceForm.get('modelo_descricao')?.value),
        "versaoCodigo": String(this.resourceForm.get('versao_codigo')?.value),
        "versaoDescricao": String(this.resourceForm.get('versao_descricao')?.value),
        "veiculoCodigo": String(this.resourceForm.get('veiculo_codigo')?.value),
        "veiculoDescricao": String(this.resourceForm.get('veiculo_descricao')?.value),
        "veiculoCor": String(this.resourceForm.get('cor')?.value),
        "veiculoNivelCombustivel": String(this.resourceForm.get('combustivel')?.value + '/4'),
        "link": this.obterLogo(),
        "fipe": this.fipe
      },
      "data": this.dadosOriginais
    }


    //send Rest
    this.rest.saveValidacaoVeiculo(postData).subscribe(
      data => {
        var response = JSON.parse(JSON.stringify(data));
        /*         if (this.checkIdGroup([1, 2])) {
                  if (response.status == 'success') {
                    if (this.resourceForm.get('usuario')?.value != 0) {
                      this.bsModalRef.hide()
                      this.rest.filter('closed')
                    }
                    else {
                      this.info.showSuccess(response.data[0].mensagem);
                      //this.closeModal.nativeElement.click();
                      this.bsModalRef.hide();
                      this.router.navigateByUrl('/veiculo?protocolo=' + this.resourceForm.get('protocolo')?.value + '&oficina=' + this.uuid_oficina);
                    }
                  }
                } */
        this.info.showSuccessWithTimer(response.data[0].mensagem);
        //this.closeModal.nativeElement.click();
        this.bsModalRef.hide();
        this.router.navigateByUrl('/veiculo?protocolo=' + this.resourceForm.get('protocolo')?.value + '&oficina=' + this.uuid_oficina);

      });


  }

}